import { forwardRef } from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const infoIconStyles = {
  ml: 0.5,
  fontSize: 16,
  verticalAlign: 'middle',
  cursor: 'pointer',
};

const InfoIcon = forwardRef(function InfoIcon(props, ref) {
  return <InfoOutlinedIcon ref={ref} sx={infoIconStyles} {...props} />;
});

export default InfoIcon;
